import React from 'react';
import './ContactUs.scss';
import { useTranslation } from "react-i18next";

function ContactUs() {
    const { t } = useTranslation();
    return (
        <div className="link">
            <a className = "link-states" href="mailto:myaccess@aircanada.ca?subject=my ACcess">
              <i className="icon-email icon link-states" />
              <p>{t(`Footer.contactUs`)}</p>
            </a> 
        </div>
    );
}

export default ContactUs;
